import SweetAlert, {SweetAlertIcon} from "sweetalert2";


export function customAlert(title: string, text: string, icon: SweetAlertIcon): void {
	SweetAlert.fire({
		title,
		text,
		icon,
		confirmButtonColor: 'var(--alert-button)',
		confirmButtonText: 'Rendben',
	});
}

export function customSuccessAlert(title: string, text: string): void {
	customAlert(title, text, 'success');
}

export function customErrorAlert(title: string, text: string): void {
	customAlert(title, text, 'error');
}

export function customWarningAlert(title: string, text: string): void {
	customAlert(title, text, 'warning');
}

export function successSaveAlert(): void {
	customSuccessAlert(translate('success-save-title'), translate('success-save-text'));
}

export function errorSaveAlert(): void {
	customErrorAlert(translate('alert-error-title'), translate('alert-error-text'));
}
